import { type FC, type ReactNode } from "react";

import ClearIcon from "@mui/icons-material/Clear";
import { Box, IconButton, Stack } from "@mui/material";

export const OptionalParamWrapper: FC<{ children: ReactNode; onRemove?: () => void }> = ({ children, onRemove }) => {
  if (!onRemove) {
    return (
      <Box minWidth={0} flexGrow={1}>
        {children}
      </Box>
    );
  }

  return (
    <Stack direction="row" alignItems="flex-start" flexGrow={1}>
      {children}
      <IconButton size="small" onClick={onRemove} sx={{ mt: 0.75 }}>
        <ClearIcon fontSize="inherit" />
      </IconButton>
    </Stack>
  );
};
